// Presentation translations for the current CMS category vocabulary. IDs, visibility and ordering remain API-driven.
export default {
  "ATV Series": "مسلسلات ATV",
  "Action": "أكشن",
  "Adventure": "مغامرات",
  "Aile": "عائلي",
  "Aksiyon": "أكشن",
  "All TV Series": "جميع المسلسلات التلفزيونية",
  "Ana Sayfa": "الرئيسية",
  "Animal Kingdom": "عالم الحيوان",
  "Animasyon": "رسوم متحركة",
  "Animation": "رسوم متحركة",
  "Belgesel": "وثائقي",
  "Belgeseller": "أفلام وثائقية",
  "Bilim Kurgu": "خيال علمي",
  "Bilim ve Teknoloji": "العلوم والتكنولوجيا",
  "Biography": "سير ذاتية",
  "Comedy": "كوميديا",
  "CosmoGo": "كوزمو غو",
  "Crime": "جريمة",
  "DaVinci": "دافنشي",
  "Dini İçerik": "محتوى ديني",
  "Discovery": "ديسكفري",
  "Diyanet": "ديانت",
  "DocuScreen": "دوكو سكرين",
  "Documentaries": "أفلام وثائقية",
  "Documentary": "وثائقي",
  "Dram": "دراما",
  "Drama": "دراما",
  "DuckTV": "داك تي في",
  "Dünyamızı Keşfedelim": "لنكتشف عالمنا",
  "Education": "تعليم",
  "En İyi 10": "أفضل 10",
  "English Club": "نادي الإنجليزية",
  "Family": "عائلي",
  "Fantastik": "فانتازيا",
  "Fantasy": "فانتازيا",
  "FilmScreen": "فيلم سكرين",
  "Gerilim": "تشويق",
  "Gezegenimiz": "كوكبنا",
  "Gizem": "غموض",
  "Hayalet Avcıları Serisi": "سلسلة صائدي الأشباح",
  "Hayvan Krallığı": "عالم الحيوان",
  "Historical": "تاريخي",
  "History": "تاريخ",
  "Horror": "رعب",
  "International Series": "مسلسلات عالمية",
  "Kanal D Series": "مسلسلات Kanal D",
  "Kemal Sunal Filmleri": "أفلام كمال سونال",
  "Kids": "أطفال",
  "Komedi": "كوميديا",
  "Korku": "رعب",
  "Macera": "مغامرات",
  "Moonbug": "مونباغ",
  "More Documentaries": "المزيد من الأفلام الوثائقية",
  "More Movies": "المزيد من الأفلام",
  "Movies": "أفلام",
  "Mystery": "غموض",
  "Myzen": "ماي زن",
  "NOW Series": "مسلسلات NOW",
  "Nat Geo Now": "ناشونال جيوغرافيك ناو",
  "Original Documentaries": "أفلام وثائقية أصلية",
  "Popular Movies": "أفلام رائجة",
  "Popular Series": "مسلسلات رائجة",
  "RENTAL": "استئجار",
  "RENTAL OLD": "استئجار سابق",
  "Rental": "استئجار",
  "Romance": "رومانسي",
  "Romantik": "رومانسي",
  "Savaş": "حرب",
  "Science & Technology": "العلوم والتكنولوجيا",
  "Science Fiction": "خيال علمي",
  "Series": "مسلسلات",
  "Seç İzle": "حسب الطلب",
  "Sinamahemen": "سينما همن",
  "SinemaHemen": "سينما همن",
  "Sinemahemen": "سينما همن",
  "Siyah Giyen Adamlar Serisi": "سلسلة رجال بملابس سوداء",
  "Star & Show TV Series": "مسلسلات Star وShow TV",
  "Studio Documentaries": "أفلام وثائقية من الاستوديو",
  "Suç": "جريمة",
  "TV Series": "مسلسلات تلفزيونية",
  "Tarih": "تاريخ",
  "TarihTV": "تاريخ تي في",
  "Tarihi": "تاريخي",
  "Tekrar İzle": "إعادة المشاهدة",
  "Thriller": "تشويق",
  "Tom Raider Serisi": "سلسلة تومب رايدر",
  "Turkish Cinema": "السينما التركية",
  "Turkish Series": "مسلسلات تركية",
  "Turksat Special": "مختارات توركسات",
  "Türk Sineması": "السينما التركية",
  "Türksat Özel": "مختارات توركسات",
  "Uzay": "الفضاء",
  "Venom Serisi": "سلسلة فينوم",
  "Viasat": "فياتسات",
  "War": "حرب",
  "Yabancı Diziler": "مسلسلات أجنبية",
  "Yaşam ve Eğlence": "نمط الحياة والترفيه",
  "Yeni Gelenler": "وصل حديثًا",
  "Yerli Diziler": "مسلسلات محلية",
  "Çocuk ve Eğitim": "الأطفال والتعليم",
  "Çok Yakında": "قريبًا",
  "Örümcek Adam Serisi": "سلسلة الرجل العنكبوت",
  "İnsanlar ve Kültür": "الناس والثقافة",
  "Kids & Education": "الأطفال والتعليم",
  "Lifestyle & Entertainment": "نمط الحياة والترفيه",
  "Religious Content": "محتوى ديني"
};
